import { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'

export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="relative min-h-screen flex flex-col">
      <Header />
      <main className="relative z-10 flex-1">{children}</main>
      <Footer />
    </div>
  )
}
